import {boot} from './boot';
import React from 'react';
import ReactDOM from 'react-dom';
import AnalyticsApp from './views/AnalyticsApp';

(async () => {
    const bootData = await boot();
    ReactDOM.render(<AnalyticsApp store={bootData.store} i18n={bootData.i18n} />, document.getElementById('main'));
})();



// WEBPACK FOOTER //
// ./src/index.tsx